import { render, staticRenderFns } from "./NotificationTemplateTreatmentDetails.vue?vue&type=template&id=053679e1&scoped=true"
import script from "./NotificationTemplateTreatmentDetails.vue?vue&type=script&lang=js"
export * from "./NotificationTemplateTreatmentDetails.vue?vue&type=script&lang=js"
import style0 from "./NotificationTemplateTreatmentDetails.vue?vue&type=style&index=0&id=053679e1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "053679e1",
  null
  
)

export default component.exports